import http from "@/http-common";

class UserService {
  getAll() {
    const url = 'user';

    return http.get(url)
    .then((response) => {
      const { data } = response;
      
      if (data) {
        return data;
      }
      else {
        return false;
      }
    })
    .catch((e) => {
      console.error(e);
      throw e;
    });
  }

  getCount(period) {
    const url = 'user/count?period=' + period;

    return http.get(url)
    .then((response) => {
      const { data } = response;
      
      if (data) {
        return data;
      }
      else {
        return false;
      }
    })
    .catch((e) => {
      console.error(e);
      throw e;
    });
  }
}

export default new UserService();